import { FETCH_PARENT, FETCH_PARENT_SUCCESS, FETCH_PARENT_FAILURE, CLEAR_PARENT } from '../actions';

const initialState = {
  parent: {},
  loading: true,
  err: null,
  haveData: false
};

export const reducer = (state = initialState, action) => {
  switch(action.type) {
    case FETCH_PARENT:
      return {
        ...state,
        loading: true,
        err: null,
        haveData: false
      };
    case FETCH_PARENT_SUCCESS:
      return {
        ...state,
        loading: false,   
        haveData: true,     
        parent: action.data
      };
    case FETCH_PARENT_FAILURE:
      return {
        ...state,
        loading: false,
        haveData: false,
        err: action.error,
        parent: {}
      };
    case CLEAR_PARENT:
      return initialState;
    default:
      return state;
  }
}